import View from './View';
import schema from './schema';
import icon from '@plone/volto/icons/chunk.svg';

const FeaturesBlock = {
  id: 'features',
  title: 'Features',
  view: View,
  icon: icon,
  group: 'castle',
  restricted: false,
  mostUsed: false,
  sidebarTab: 1,
  blockSchema: schema,
};

export default FeaturesBlock;